import { useMutation, useQueryClient } from '@tanstack/react-query';
import sportsApi from '../../../utils/sportsApi';
import { CommonKey } from '../../../types/api';

const useCreateCampaign = ({ clientId }: { clientId: number }) => {
    const queryClient = useQueryClient();

    const createCampaign = async (payload: any) => {
        return await sportsApi
            .url(`/clients/${clientId}/social-campaigns`)
            .json(payload)
            .post()
            .json();
    };

    const mutation = useMutation({
        mutationFn: createCampaign,
        onSuccess: (data) => {
            queryClient.setQueryData([CommonKey.Campaigns, clientId], (oldData: any[]) => {
                const campaigns = [...(oldData || []), data];
                return campaigns;
            });
        },
    });

    return mutation;
};

export default useCreateCampaign;
